module.exports = __webpack_public_path__ + "static/img/JackRobinson.69956b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JackRobinson.jpg
// module id = o5qk
// module chunks = 0